module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/bank-details/bank-details-grid/bank-details-grid.component.css
// module id = ./src/app/hrms/serviceregister/bank-details/bank-details-grid/bank-details-grid.component.css
// module chunks = main